import useCapabilities, { useCanViewPersonGroupsBool } from "@/hooks/useCapabilities";

/** Capability check for person Groups. Denied users are redirected to person overview. */
export function usePersonGroupsAccess() {
  const { loaded } = useCapabilities();
  const canViewPersonGroups = useCanViewPersonGroupsBool();

  return {
    loaded,
    canViewPersonGroups
  };
}
